export const caseInsensitiveIncludes = (mainString: string, checkForInclusion: string) =>
  mainString
    .replace(/\s+/g, '')
    .toUpperCase()
    .includes(checkForInclusion.replace(/\s+/g, '').toUpperCase());
